import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const EVENT_TYPE_CORE_FIELDS = gql`
  fragment EventTypeCoreFields on EventType {
    id
    name
    emoji
  }
`;

export const EVENT_TYPE_FIELDS = gql`
  ${EVENT_TYPE_CORE_FIELDS}
  fragment EventTypeFields on EventType {
    ...EventTypeCoreFields
    parent {
      ...EventTypeCoreFields
    }
  }
`;

export const EVENT_TYPE = gql`
  ${EVENT_TYPE_FIELDS}
  query EventType($id: ID!) {
    eventType(id: $id) {
      ...EventTypeFields
    }
  }
`;

export const EVENT_TYPES = gql`
  ${EVENT_TYPE_FIELDS}
  query EventTypes {
    eventTypes {
      ...EventTypeFields
    }
  }
`;

export const CREATE_EVENT_TYPE = gql`
  ${EVENT_TYPE_CORE_FIELDS}
  mutation CreateEventType ($input: CreateEventTypeInput!) {
    createEventType (input: $input) {
      eventType {
        ...EventTypeCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_EVENT_TYPE = gql`
  ${EVENT_TYPE_CORE_FIELDS}
  mutation UpdateEventType ($input: UpdateEventTypeInput!) {
    updateEventType (input: $input) {
      eventType {
        ...EventTypeCoreFields
      }
      ${ERRORS}
    }
  }
`;
